const COLORS = {
  primary: "#1890ff",
  primaryDark: "#001529",
  lightGray: "#f5f5f5",
  white: "#FFFFFF",
  text: "#7a7a7a",
  black: "#000000",
  danger: "#f50",
  danger1: "#FF6461",
  success: "#87d068",
  success1: "#55B659",
  warning: "#FFB302",
  pink: "#D52385",
  activePlan: "#012C54",
};

export { COLORS };
